<div class="bell-contet">
  <span *ngIf="count > 0" class="count">{{count}}</span>
  <span *ngIf="count > 0" class="fa fa-bell-o fa-2x"></span>
</div>
